/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.commerce.buyer.portal.rpc.BuyerPreviewDataRpc
 */

export const getPaymentMethodsRpc = {
  serviceName: 'com.hubspot.commerce.buyer.portal.rpc.BuyerPreviewDataRpc',
  rpcName: 'getPaymentMethods',
  auth: 'external',
  fingerprint: 's0CMaxJ_mByZFR9yZ1Y_YLYD5Evuxlnt',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getCurrentSubscriptionsRpc = {
  serviceName: 'com.hubspot.commerce.buyer.portal.rpc.BuyerPreviewDataRpc',
  rpcName: 'getCurrentSubscriptions',
  auth: 'external',
  fingerprint: 's0CMaxJ_mBzbE1SkpjIKZrYD5Evuxlnt',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getSubscriptionsRpc = {
  serviceName: 'com.hubspot.commerce.buyer.portal.rpc.BuyerPreviewDataRpc',
  rpcName: 'getSubscriptions',
  auth: 'external',
  fingerprint: 's0CMaxJ_mBzbE1SkpjIKZrYD5Evuxlnt',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getInactiveSubscriptionsRpc = {
  serviceName: 'com.hubspot.commerce.buyer.portal.rpc.BuyerPreviewDataRpc',
  rpcName: 'getInactiveSubscriptions',
  auth: 'external',
  fingerprint: 's0CMaxJ_mBzbE1SkpjIKZrYD5Evuxlnt',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getInvoicesRpc = {
  serviceName: 'com.hubspot.commerce.buyer.portal.rpc.BuyerPreviewDataRpc',
  rpcName: 'getInvoices',
  auth: 'external',
  fingerprint: 's0CMaxJ_mBwl7qi3tRHjBbYD5Evuxlnt',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getCommercePaymentsRpc = {
  serviceName: 'com.hubspot.commerce.buyer.portal.rpc.BuyerPreviewDataRpc',
  rpcName: 'getCommercePayments',
  auth: 'external',
  fingerprint: 's0CMaxJ_mByDz2XheWyAbrYD5Evuxlnt',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};